import commonNav from '@/components/common-nav/index.vue';
import commonModal from '@/components/common-modal/index.vue';
import common from '@/util/common';
import {
	createNamespacedHelpers
} from 'vuex';
const sroreName = {
	myInfo: 'myInfo',
};
const {
	mapState,
	mapActions,
} = createNamespacedHelpers(sroreName.myInfo);
export default {
	data() {
		return {
			modalType: '',
			modalTitle: '',
			modelSubTitle: '',
			isModalShow: false,
			recharge_open: '',
			getConfigInfo: null,
			isLogoutFlag: false,
			wxAppid: '',
			loginPath: '/',
			loginWay: '',
		};
	},
	created(){
		console.log('window.history',window.history)
		this.getConfigInfo = JSON.parse(sessionStorage.getItem('configInfo'));
		this.loginWay = this.getConfigInfo.loginWay;
		this.loginPath = this.loginWay === 0?(this.loginPath + '?isBankAutoLoginFlag=0') : (this.loginPath + this.getConfigInfo.loginSearch);
		console.log(this.getConfigInfo)
	},
	async mounted() {
		await this.getUserData({
			content: this,
			data: {
				AccountNo: this.getConfigInfo.AccountNo
			},
			toastCallBack: (respond)=>{
				console.log('respond',respond);
				if(respond.data.code == 40002){
					common.jump(this,'cardList');
				}
			}
		});
		this.recharge_open = this.getConfigInfo.recharge_open;
		console.log('this.recharge_open',this.recharge_open);
		//this.wxEmpowerCallBack();
	},
	components: {
		'common-nav': commonNav,
		'common-modal': commonModal,
	},
	watch: {
		
	},
	computed:{
		...mapState({
			userData(state){
				return state.userData
			} 
		}),
		balance(){
			/* 余额 */
			const userData = this.userData;
			if(userData && userData.Balance){
				return userData.Balance;
			}
		},
		userName(){
			/* 用户名 */
			const userData = this.userData;
			if(userData && userData.Name){
				return userData.Name;
			}
		},
		certCode(){
			/* 手机号 */
			const userData = this.userData;
			if(userData && userData.CertCode){
				if(userData.CertCode.indexOf('\u0000')){
					return userData.CertCode.replace('\u0000','&').split('&')[0];
				}else{
					return userData.CertCode;
				}
			}
		},
		department(){
			/* 部门 */
			const userData = this.userData;
			if(userData && userData.department){
				return userData.department;
			}
		},
		notice(){
			/* 通告 */
			const userData = this.userData;
			if(userData && userData.notice){
				return userData.notice;
			}
		},
		accountStatus(){
			/* 账户状态 */
			const userData = this.userData;
			if(userData && (userData.status || userData.status == 0)){
				return userData.status;
			}
		},
		pathObj(){
			return {
				path: '/?isWxLoginFlag=1'
			};
		}
	},
	methods: {
		...mapActions({
			getUserData: 'getUserData',
			lostAccount: 'lostAccount',
			postSignOut: 'postSignOut',
			postWxLogin: 'postWxLogin',
			postRedirect: 'postRedirect',
		}),
		openModal(e){
			let dataset = e.currentTarget.dataset,
				title = dataset.title,
				subTitle = dataset.subTitle,
				type = dataset.type;
			this.modalType = type;
			this.modalTitle = title;
			this.modelSubTitle = subTitle;
			this.isModalShow = true;
		},
		jumpPage(e){
			common.jumpPage(this,e.currentTarget);
		},
		async modalSure(data){
			const param = {
				content: this,
				data: {
					AccountNo: this.userData.AccountNo,
					PassWord: data?data.password : '',
					Operation: this.modalType == 'loss'?1 : 2,
				}
			};
			console.log(param);
			this.isModalShow = false;
			const lossStatus = await this.lostAccount(param);
			if(lossStatus){
				this.getUserData({
					content: this,
					data: {
						AccountNo: this.getConfigInfo.AccountNo
					}
				});
			}
		},
		rightBtnHandle(){
			this.$router.push({
				name: 'cardList',
			});
		},
		logoutHandle(){
			this.isLogoutFlag = true;
		},
		async sureLogout(){
			const param = {
				content: this
			};
			this.isLogoutFlag = false;
			const logoutStatus = await this.postSignOut(param);
			console.log('logoutStatus',logoutStatus)
			if(logoutStatus && logoutStatus.code == 1){
				common.jump(this, this.loginPath, {}, 'query');
			}
		},
		async wxEmpowerHandle(){
			const href = location.href;
			const url = href.split('?')[0];
			const redirect_uri = encodeURIComponent(url);
			console.log(redirect_uri)
			const param = {
				content: this
			};
			const wxLoginData = await this.postWxLogin(param);
			if(wxLoginData && wxLoginData.code == 1){
				this.wxAppid = wxLoginData.data;
				window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
			}
		},
		wxEmpowerCallBack(){
			const search = location.search.substring(1);
			console.log('search',search,search.indexOf('code'))
			if(search.indexOf('code') >= 0){
				const codeStr = search.split('=')[1];
				console.log(codeStr)
				if(codeStr){
					const code = codeStr.split('&')[0];
					console.log(code)
					this.postRedirectHandle(code);
				}
			}
		},
		async postRedirectHandle(code){
			const param = {
				content: this,
				data: {
					code: code,
				}
			};
			const redirectData = await this.postRedirect(param);
			console.log('redirectData',redirectData,redirectData.data.msg);
			if (redirectData && redirectData.code == 1) {
				/* 重新给token做一下cookie */
				document.cookie = `${encodeURIComponent("token")}=${encodeURIComponent(redirectData.data.token)}`;
				common.toast(redirectData.msg, 'success');
			}
		},
	},
};
